import onGuidedFormulationSuggestionSelectedInternal from '../actions/onGuidedFormulationSuggestionSelectedInternal';
import onRemoveGuidedFormulationPillInternal from '../actions/onRemoveGuidedFormulationPillInternal';
import onSuggestionSelected from '../actions/onSuggestionSelected';
import getScenarioStore from '../store/getScenarioStore';
import { createDefaultSearchStore } from '../store/store';
import getSegmentSearchBoxText from '../utils/getSegmentSearchBoxText';
import { trace } from 'owa-trace';
import { mutator } from 'satcheljs';

mutator(onSuggestionSelected, actionMessage => {
    getScenarioStore(actionMessage.scenarioId).suggestionSegments.clear();
});

mutator(onGuidedFormulationSuggestionSelectedInternal, actionMessage => {
    const store = getScenarioStore(actionMessage.scenarioId);
    const segments = actionMessage.segments;
    const lastSegment = segments.slice(-1)[0];

    /**
     * If the last segment shouldn't be a pill (i.e. a text segment), then set
     * it as the searchText. All other segments should be added to the store.
     */
    if (lastSegment.Type === 'Person') {
        // Add segments represented as pills to the store.
        for (const segment of segments) {
            store.suggestionSegments.set(segment.DisplayText, segment);
        }
    } else {
        // Add segments represented as pills to the store.
        const pillSegments = segments.slice(0, -1);
        for (const segment of pillSegments) {
            store.suggestionSegments.set(segment.DisplayText, segment);
        }

        // Add last segment to the search box as text.
        store.searchText = getSegmentSearchBoxText(lastSegment);
    }
});

mutator(onRemoveGuidedFormulationPillInternal, actionMessage => {
    const { scenarioId, segmentKey } = actionMessage;

    const store = getScenarioStore(scenarioId);
    const suggestionSegments = store.suggestionSegments;

    /**
     * If an entry for the given segmentKey exists, remove it. Otherwise, log
     * an error because that shouldn't happen.
     */
    if (suggestionSegments.has(segmentKey)) {
        // Remove map entry for given key.
        suggestionSegments.delete(segmentKey);

        // Reset selected pill index.
        store.selectedPillIndex = createDefaultSearchStore().selectedPillIndex;
    } else {
        trace.warn(
            "removeSuggestionSegmentFromSearchBox was dispatched with a segmentKey that doesn't exist in searchStore.suggestionSegments map."
        );
    }
});
